const toggleButton = document.getElementById('toggle');
const topicsLocations = document.getElementById('topics-locations');

function handleToggleVisible () {
  toggleButton.classList.toggle('active');
  topicsLocations.classList.toggle('visible');
}

function init () {
  if (toggleButton) {
    toggleButton.addEventListener('click', handleToggleVisible);
  }
}

module.exports = {
  init
};



// WEBPACK FOOTER //
// ./src/js/vanilla/toggles.js